export default __webpack_public_path__ + "static/media/scarry.47327789.mp4";